import React from 'react';
import styled from 'styled-components';
import {CAROUSEL, DATA_TRACK_TYPE_CTA} from '../../../../lib/constants';
import {
  attachLocale,
  toSlug,
  trackAnalyticsNew,
} from '../../../../lib/utils';
import CenteredRowDiv from './CenteredRowDiv';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import Button from '../Button/Button';

const WrapperDiv = styled.div`
  width: 100%;
`;

// *** Desktop View ***
const adjustPadding = (viewType) => {
  if (viewType === CAROUSEL) {
    return p => p.theme.unit(5);
  }
  return p => p.theme.unit(10);
};

const SectionTitleH2 = styled.h2`
  ${({ theme }) => theme.typographyRebrand.heading['2xl']}
  color: ${p => p.theme.c.text.primary};
  margin: 0;
  padding-top: ${p => p.theme.unit(4)};
  padding-bottom: ${p => p.theme.unit(2)};
`;

const PaddedCenteredRowDiv = styled(CenteredRowDiv)`
  padding: ${p => p.theme.unit(4)} 0;
`;

// *** Mobile View ***
const MobileSectionTitleH2 = styled(SectionTitleH2)`
  margin: 0 ${p => p.theme.unit(1)};
  padding-bottom: ${p => p.theme.unit(3)};
  text-align: center;
`;

const TitledSection = (props) => {
  const {
    children,
    sectionTitle,
    showDisplayName,
    buttonText,
    buttonUrl,
    viewType,
    locale,
    slug,
  } = props;


  const resolvedUrl = attachLocale(buttonUrl, locale);
  const sectionIdentifier = slug || toSlug(sectionTitle);
  const track = trackAnalyticsNew({
    url: resolvedUrl,
    location: sectionIdentifier ? `page:${sectionIdentifier}` : undefined,
    name: toSlug(buttonText),
  });

  const DesktopChildrenBodyToUse = () => {
    if (showDisplayName && sectionTitle) {
      return (<div >{ children }</div>);
    }
    return children;
  };

  const DesktopBody = () => (
    <WrapperDiv>
      {showDisplayName && sectionTitle && <SectionTitleH2>{ sectionTitle }</SectionTitleH2>}
      <DesktopChildrenBodyToUse />
      {buttonText && resolvedUrl &&
        <PaddedCenteredRowDiv>
          <Button
            variant="primary"
            size="large"
            buttonText={buttonText}
            dataTrackType={DATA_TRACK_TYPE_CTA}
            {...track}
          />
        </PaddedCenteredRowDiv>}
    </WrapperDiv>
  );

  const MobileBody = () => (
    <WrapperDiv>
      {showDisplayName && sectionTitle && <MobileSectionTitleH2>{ sectionTitle }</MobileSectionTitleH2>}
      { children }
      {buttonText && resolvedUrl &&
        <PaddedCenteredRowDiv>
          <Button
            variant="primary"
            size="large"
            buttonText={buttonText}
            dataTrackType={DATA_TRACK_TYPE_CTA}
            {...track}
          />
        </PaddedCenteredRowDiv>}
    </WrapperDiv>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={DesktopBody()}
      mobileChildren={MobileBody()} />);
  return renderComp;
};

export default TitledSection;
